<template>
  <div class="tab-item">
    <div class="cat-name">图书分类</div>
    <div id="chart-book"></div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import { statisticCategory } from "@/api/book";

export default {
  props: ["deptId"],
  watch: {
    deptId: {
      handler(val, oldVal) {
        console.log(val, oldVal);
        this.query();
      },
      immediate: true,
    },
  },
  data() {
    return {
      bookCategory: [],
      chart: null,
    };
  },
  mounted() {
    this.drawChart(this.bookCategory);
  },
  methods: {
    drawChart(data) {
      const chart = new Chart({
        container: "chart-book",
        autoFit: true,
        height: 250,
      });
      chart.data(data);
      chart.scale("count", {
        nice: true,
      });
      chart.axis("categoryName", {
        // tickLine: null,
      });
      chart.legend(false);
      chart
        .interval()
        .position("categoryName*count")
        .color("categoryName", () => "#4983F5")
        .size("count", () => 20);
      chart.render();
      this.chart = chart;
    },
    query() {
      statisticCategory({ deptId: this.deptId })
        .then(({ code, data }) => {
          if (code === 0) {
            this.bookCategory = data;
            this.changeChart(data);
          }
        })
        .catch(() => {});
    },
    changeChart(data) {
      this.chart.clear();
      this.chart.data(data);
      this.chart.scale("count", {
        nice: true,
      });
      this.chart.axis("categoryName", {
        tickLine: null,
      });
      this.chart.legend(false);
      this.chart
        .interval()
        .position("categoryName*count")
        .color("categoryName", () => "#4983F5")
        .size("count", () => 20);
      this.chart.render();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  padding: 20px 24px;
  padding-top: 10px;
  .cat-name {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #343c4a;
    padding: 32px 0 24px 0;
  }
}
</style>